<template>
    <el-card>
        <app-modal-new-project v-if="addNewProject"></app-modal-new-project>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">Inicio</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/dashboard/proyectos' }">Proyectos</el-breadcrumb-item>
            <el-breadcrumb-item >{{breadcrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
        <br />
        <el-form @submit.native.prevent="save" ref="form" label-position="top" id="user" >
            <el-row type="flex" justify="space-between">
                <el-col :span="6">
                    <el-form-item label="Icono" >
                        <el-input v-model="form.icono"  :prefix-icon="form.icono"></el-input>
                        <a href="https://glyphsearch.com/?copy=class&library=ionicons" target="_blank" class="link">ionicons</a>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="Nombre">
                        <el-input v-model="form.nombre"></el-input>
                    </el-form-item>
                </el-col>
                    <el-col :span="7">
                    <el-form-item label="URl">
                        <el-input v-model="form.url" @change="setIframe()"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" >
                <el-col :span="4">
                        <el-form-item label="Ancho iframe">
                            <el-input v-model="form.width"></el-input>
                        </el-form-item>
                </el-col>
                <el-col :span="1"></el-col>
                <el-col :span="4">
                        <el-form-item label="Alto iframe">
                            <el-input v-model="form.height"></el-input>
                        </el-form-item>
                </el-col>
                <el-col :span="1"></el-col>
                <el-col :span="4">
                    <el-form-item label="Proyecto asociado">
                        <el-select v-model="project" multiple placeholder="Select" @change="changueProjectc" @remove-tag="deleteProjectc">
                            <el-option
                                v-for="(item, index) in proyectos"
                                :key="index"
                                :label="item.proyecto"
                                :value="item.id" >
                            </el-option>
                        </el-select>
                        <a href="#" @click.prevent="addProject()" class="link">Añadir nuevo proyecto</a>
                    </el-form-item>
                </el-col>
                <el-col :span="1"></el-col>          
                <el-col :span="10">
                    <el-form-item label="Visble en menú">
                        <el-radio-group v-model="form.visible">
                            <el-radio-button :label="1">Sí</el-radio-button>
                            <el-radio-button :label="0">No</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="space-between">
                <el-col :span="24">
                    <el-form-item label="Descripción">
                        <el-input type="textarea" v-model="form.descripcion" :autosize="{ minRows: 4}"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
                <el-col :span="24">
                    <el-form-item label="Previsualización" v-if="showIframe">
                        <iframe  :src="form.url" width="100%" height="400" frameborder="0"></iframe>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <button type="submit" class="el-button el-button--primary" form="user"><span>{{btn}}</span></button>
                    <el-button type="primary" @click="close()">Cancelar</el-button>                    
                </el-col>
            </el-row>

        </el-form>
    </el-card>
</template>

<script>
    import sha1 from 'sha1'
	import ApiService from '@/common/api.service'
    import ModalProject from '@/components/Dashboard/Modals/addNewProject'
	import { mapGetters } from "vuex"
    export default {
        name: 'report',
        components: {
            'app-modal-new-project': ModalProject
        },
        computed: {
			...mapGetters(['isAdmin', 'currentUser'])
		},
        created () {
            this.$root.$emit('isConnect')  
			this.$root.$on('closeModal', ()=> {
				this.addNewProject = false
				this.getProjects()
			})

            if(this.$route.params.informe_id){
                this.breadcrumb = 'Edición informe'
                this.btn = 'Actualizar'
                this.id = this.$route.params.informe_id
                setTimeout(() => {
                    setTimeout(() => {
                        this.getProject()                    
                    }, 100);
                    this.getReport()
                }, 200);
            }else{
                this.breadcrumb = 'Nuevo informe'                
            }
            this.getProjects()
            this.showBottons = true
        },
        data () {
            return {
                id: null,
                btn: 'Crear',
                form: {
                    icono: null,
                    url: null,
                    nombre: null,
                    descripcion: null,
                    user_id: null,
                    visible: null,
                    width: 1366, 
                    height: 1000
                },
                old: {
                    icono: null,
                    url: null,
                    nombre: null,
                    descripcion: null,
                    user_id: null,
                    visible: null,
                    width: 1366, 
                    height: 1000

                },
                project: [],
                proyecto: {
                    id: null,
                    proyecto: null
                },
                proyectos: null,
                borrado: false,
                addNewProject: false,
                users: null,
                showIframe: false,
                error: false
            }
        },
        methods: {            
            async getProject(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: false,
                    method: 'SELECT',
                    fields: ['id', 'project_id'],
                    where: ' report_id = ' + this.id,
                    table: 'reports_projects',
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.project =  response.data.map( (e)=>  {
                            return e.project_id
                        })
                        this.proyecto =  response.data
                        this.proyectoOld = response.data
                    }
                })
            },

            async getProjects(){
                let data = {
                    token: localStorage.getItem("analiticatoken"),
                    single: false,
                    method: 'select',
                    fields: ['id','proyecto'],
                    table: 'proyectos',
                }
                if(this.currentUser.rol != 1) {
                    data.fields = ['proyectos.*'],
                    data.inner = [
                        'users_projects, project_id, id, proyectos',
                    ],
                    data.where = ' users_projects.user_id = ' + this.currentUser.id
                }
                ApiService.post("public/v1", data).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.proyectos = response.data
                    }else{
                        this.proyectos = []
                    }
                })
            },
            async getReport(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'select',
                    fields: ['informes.id', 'informes.icono', 'informes.url', 'informes.nombre', 'informes.descripcion', 'informes.visible', 'informes.width', 'informes.height'],
                    where: ' informes.id = ' + this.id,      
                    table: 'informes'
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.form = {
                            icono: response.data.icono,
                            url: response.data.url,
                            nombre: response.data.nombre,
                            descripcion: response.data.descripcion,
                            user_id: response.data.user_id,
                            height: response.data.height,
                            width: response.data.width,
                            visible: parseInt(response.data.visible)
                        }
                        this.old = {
                            icono: response.data.icono,
                            url: response.data.url,
                            nombre: response.data.nombre,
                            descripcion: response.data.descripcion,
                            user_id: response.data.user_id,
                            height: response.data.height,
                            width: response.data.width,
                            visible: parseInt(response.data.visible)                  
                        }
                        this.showIframe = true
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 100);
                })
            },
            save() {
                this.$root.$emit('isConnect')  
                if(this.project.length == 0){
                    this.$root.$emit('msgError','El campo "Proyecto asociado" es obligatorio')
                    this.error = true 
                    return false
                }else{
                    this.error = false
                }

                if(!this.form.nombre){
                    this.$root.$emit('msgError','El campo nombre es obligatorio')
                    this.error = true 
                    return false
                }else{
                    this.error = false
                }
                if(!this.form.url){
                    this.$root.$emit('msgError','El campo url es obligatorio')
                    this.error = true
                    return false                     
                }else{
                    this.error = false
                }

                if(this.error == false){
                    this.id > 0 ? this.update() : this.insert() ; 
                }

            },
            async insert(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'INSERT',
                    table: 'informes',
                    form: {
                        icono: this.form.icono,
                        url: this.form.url,
                        nombre: this.form.nombre,
                        descripcion: this.form.descripcion,
                        visible: this.form.visible
                    }
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        ApiService.post("public/v1", {
                            token: localStorage.getItem("analiticatoken"),
                            single: true,
                            method: 'INSERT',
                            table: 'informe_usuario',
                            form: {
                                informe_id: parseInt(response.data),
                                user_id: this.form.user_id
                            }
                        }).then(response => {
                            if(response.data != 'Algo ha fallado'){
                                this.id = parseInt(response.data)
                                setTimeout(() => {
                                    this.project.forEach( e => {
                                        this.insertProject(e)
                                    });
                                }, 100);

                                this.$root.$emit('msgSuccess', 'Registro insertado')
                                setTimeout(() => {
                                    this.$router.push('/dashboard/proyectos');                        
                                }, 2000);
                            }else{
                                this.$root.$emit('msgError', 'Algo ha fallado')
                            }
                        })
                    }else{
                        this.$root.$emit('msgError', 'Algo ha fallado')
                    }
                })
            },
            async update(){

                if(this.form.icono != this.old.icono ){
                    this.error = true
                }
                if(this.form.nombre != this.old.nombre ){
                    this.error = true
                }
                if(this.form.url != this.old.url ){
                    this.error = true
                }
                if(this.form.visible != this.old.visible ){
                    this.error = true
                }
                if(this.form.descripcion != this.old.descripcion ){
                    this.error = true
                }
                if(this.form.width != this.old.width ){
                    this.error = true
                }
                if(this.form.height != this.old.height ){
                    this.error = true
                }
                if( this.form.user_id != this.old.user_id && this.error == false){
                    // this.updatePivot()
                }else if(this.error == true){
                    ApiService.post("public/v1", {
                        token: localStorage.getItem("analiticatoken"),
                        single: true,
                        method: 'UPDATE',
                        id: this.id,
                        table: 'informes',
                        form: {
                            icono: this.form.icono,
                            url: this.form.url,
                            nombre: this.form.nombre,
                            descripcion: this.form.descripcion,
                            visible: this.form.visible,
                            height: this.form.height,
                            width: this.form.width,
                        }
                    }).then(response => {
                        if(response.data == 1){
                            this.$root.$emit('msgSuccess', 'Registro insertado')
                            setTimeout(() => {
                                this.$router.push('/dashboard/proyectos');                        
                            }, 2000);
                        }else{
                            this.$root.$emit('msgError', 'Algo ha fallado')
                        }
                    })
                }
            },
            addProject(){
                this.addNewProject = true
            },
            deleteProjectc(e){
                if(this.id){
                    this.borrado = e
                }
            },
            changueProjectc(e){
                this.$root.$emit('isConnect')  
                setTimeout(() => {
                    if(this.id){
                        if(this.borrado == false){
                            this.insertProject(parseInt(e[e.length - 1]))
                        }else{
                            this.proyectoOld.filter( p => {
                                if(this.borrado == p.project_id) {
                                    this.updateProjectc(p.id)
                                    this.borrado = false
                                }
                            })
                        }
                    }                    
                }, 500);
            },
            async insertProject(p){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'INSERT',
                    table: 'reports_projects',
                    form: {
                        report_id: this.id,
                        project_id: p
                    }
                }).then( response => {
                    this.$root.$emit('msgSuccess','Registro actualizado con éxito')
                })
            },
            async updateProjectc(p) {
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'DELETE',
                    id: p,
                    table: 'reports_projects',
                }).then( response => {
                    this.$root.$emit('msgSuccess', 'Registro actualizado con éxito')
                })
                this.borrado = false
            },
            setIframe() {
                if(this.form.url.length > 10) {
                    this.showIframe = true
                }else{
                    this.showIframe = false                    
                }
            },
            close(){
                this.$root.$emit('isConnect')
                this.$router.replace('/dashboard/proyectos')
            }
        }
    }
</script>


<style scoped>
    iframe {
        border: 1px solid black;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/forms/informe.vue